import React, { useState } from "react";

import "./WalletIdInput.scss";

interface IWalletIdInput {
  walletIdValue?: string | null;
  setWalletIdValue?: React.Dispatch<React.SetStateAction<string | null>>;
}

const WalletIdInput = ({
  walletIdValue,
  setWalletIdValue,
}: IWalletIdInput) => {
  const [inputFocused, setInputFocused] = useState(false);

  const onChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setWalletIdValue && setWalletIdValue(e.target.value);
  };

  const handleFocus = () => {
    setInputFocused(true);
  };

  const handleBlur = () => {
    if (walletIdValue && walletIdValue.length === 0) {
      setInputFocused(false);
    } else {
      setInputFocused(true);
    }
  };
  return (
    <div className="u-i-p-control-item-holder-bc">
      <div
        className={`form-control-bc default ${inputFocused ? "focused" : ""}`}
      >
        <label className="form-control-label-bc inputs">
          <input
            type="text"
            inputMode="decimal"
            className="form-control-input-bc"
            name="name"
            step={0}
            defaultValue=""
            value={walletIdValue || ""}
            onChange={onChangeInput}
            onFocus={handleFocus}
            onBlur={handleBlur}
          />
          <i className="form-control-input-stroke-bc" />
          <span className="form-control-title-bc ellipsis">Wallet Id</span>
        </label>
      </div>
    </div>
  );
};

export { WalletIdInput };
